define('modules/form_editor/views/field_editor_title',['require','exports','module','base/view','i18n','ldsh!../templates/field_editor_title'],function(require, exports, module){
  "use strict";
  var BaseView = require("base/view"),
      i18n = require("i18n");
  module.exports = BaseView.extend({
    template: require("ldsh!../templates/field_editor_title"),
    helpers: function(){
      var name = this.model.name.split(":").pop();
      return {
        elementName: i18n.t("formEditor.names." + name)
      };
    },
    onRender: function() {
      this.$el.i18n();
    }
  });
});

